import React from 'react';
import { Phone, MessageCircle, Wrench } from 'lucide-react';

const StickyMobileCTA = ({ onGetQuote }) => {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-gray-200 bg-white/95 backdrop-blur-md shadow-[0_-6px_20px_rgba(0,0,0,0.08)]"
      data-testid="sticky-mobile-cta"
    >
      <div className="grid grid-cols-3 divide-x divide-gray-200">
        <button
          onClick={onGetQuote}
          className="flex flex-col items-center justify-center py-3 active:bg-gray-50"
          style={{ color: '#00B3B3' }}
          data-testid="mcta-quote"
        >
          <Wrench className="w-5 h-5 mb-0.5" />
          <span className="text-[11px] font-bold uppercase tracking-wide">Quote</span>
        </button>
        <a
          href="tel:2244199922"
          className="flex flex-col items-center justify-center py-3 text-gray-800 active:bg-gray-50"
          data-testid="mcta-call"
        >
          <Phone className="w-5 h-5 mb-0.5" />
          <span className="text-[11px] font-bold uppercase tracking-wide">Call</span>
        </a>
        <a
          href="https://wa.me/12244199922"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 active:bg-gray-50"
          style={{ color: '#25D366' }}
          data-testid="mcta-whatsapp"
        >
          <MessageCircle className="w-5 h-5 mb-0.5" fill="currentColor" />
          <span className="text-[11px] font-bold uppercase tracking-wide">WhatsApp</span>
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
